export enum ManifestType {
	STANDARD = "STANDARD",
	SMALL = "SMALL",
	TACACS = "TACACS"
}

export enum DownloadKind {
	OVA_LATEST = "latest",
	OVA_LATEST_SMALL = "latestsmall",
	HYPER_V_LATEST = "latesthyperv",
	HYPER_V_LATEST_SMALL = "latesthypervsmall",
	TACACS = "tacacs"
}

export interface Manifest {
	kind: DownloadKind;
	name: string;
	url: string;
	version: string;
	size: string;
	md5: string;
}

export interface CombinedManifest {
	[key: string]: Manifest;
}
